<div class="row">
  <div class="col s12 m12 l12">
    <form #cashCreditForm="ngForm" name="cashCreditForm" id="cashCreditForm" method="POST"
      (ngSubmit)="getCashCreditApplication()">
      <div class="info-section">
        <div class="text-center">
          <img class="merchant-logo" *ngIf="merchantName" [src]="s3BucketUrl+'/logos/'+(merchantName|lowercase)+'.png'">
        </div>
        <div class="center range-slider">
          <p class="loan-amount" *ngIf="sliderMinRange !== sliderMaxRange">
            Select your loan amount
          </p>
          <div class="loan-amount" *ngIf="sliderMinRange === sliderMaxRange">
            Your loan amount is <span [textContent]="sliderMinRange*1000 | RupeeCurrencyPipe"></span>
          </div>
          <nouislider *ngIf="sliderMinRange && sliderMaxRange" id="amount" name="amount"
            [config]="cashCreditSliderConfig" [(ngModel)]="cashCredit.amount" (ngModelChange)="selectAmount($event)" (end)="fetchPricingData()">
          </nouislider>
        </div>
        <div class="clr"></div>
      </div>
      <div class="loader-gif-container" *ngIf="isLoaderVisible">
        <div class="loader-text">Updating EMI plan</div>
        <img class="loader-gif" src="https://assets.zestmoney.in/assets/customers/gifs/emi-updation.gif" alt="Fetching EMI Options">
      </div>
      <div class="emi-options" *ngIf="!isLoaderVisible">
        <div class="emi-title">
          Choose an EMI plan
        </div>
        <div class="emi-options">
          <div class="default-plans" *ngIf="recommendedOptions && recommendedOptions.length > 0">
            <ul class="options-btn">
              <li class="col s4" *ngFor="let option of recommendedOptions">
                <input class="with-gap" name="group1" type="radio" [id]="'rd'+option.NumberOfMonths+1"
                  [checked]="cashCredit && option.NumberOfMonths == cashCredit.tenure" (click)="updateTenure(option)" />
                <label class="currency" [for]="'rd'+option.NumberOfMonths+1"
                  [textContent]="(option.TotalMonthlyAmount | RupeeCurrencyPipe) + '/mo'"></label>
                <span class="month-label" [textContent]="option.NumberOfMonths + ' months'"></span>
              </li>
            </ul>
          </div>
          <div class="clr"></div>
          <div class="other-plans" *ngIf="otherOptions && otherOptions.length > 0">
            <ul materialize="collapsible" class="collapsible other-plans" data-collapsible="accordion">
              <li>
                <div class="collapsible-header or">
                  <span class="plans-label text-blue">More Plans</span>
                  <span class="arrow"></span>
                </div>
                <div class="collapsible-body recommended-options">
                  <ul class="options-btn">
                    <li class="col s3" *ngFor="let option of otherOptions">
                      <input class="with-gap" name="group1" type="radio" [id]="'rd'+option.NumberOfMonths+1"
                        [checked]="cashCredit && option.NumberOfMonths == cashCredit.tenure"
                        (click)="updateTenure(option)" />
                      <label class="currency" [for]="'rd'+option.NumberOfMonths+1"
                        [textContent]="(option.TotalMonthlyAmount | RupeeCurrencyPipe) + '/mo'"></label>
                      <span class="month-label" [textContent]="option.NumberOfMonths + ' months'"></span>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="footer-message">
        <span>You will receive Rs344004 into your bank account</span><span class="info-icon">?</span>
      </div> -->
      <div class="row amount-breakup-section" *ngIf="processingFee > 0">
        <div class="col s12 m12 l12 center">
          <div class="loader" *ngIf="fetchingProcessingFee">
            Calculating...
          </div>
          <div class="text-wrapper" *ngIf="!fetchingProcessingFee">
            You will receive &nbsp; <span [textContent]="disbursalAmount | RupeeCurrencyPipe"></span> &nbsp; into your bank account<span (click)="toggleAmountBreakupModal('open')" class="question-mark-icon"></span>
          </div>
        </div>
      </div>
      <div class="row cash-cta">
        <div class="col s12 m12 l12 center">
          <button type="submit" class="btn waves-effect zest-btn ladda-button get-cash-btn">
            <span>GET CASH NOW</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<div id="amountBreakup" class="modal amount-breakup-modal" materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-content text-left">
    <div class="close-button" (click)="toggleAmountBreakupModal('close')">x</div>
    <div class="modal-title">
      Loan details
    </div>
    <div class="row">
      <div class="col s6 m6 l6 row-titles">
        <div>Loan amount</div>
        <div>Processing fee</div>
        <div>Amount disbursed</div>
      </div>
      <div class="col s6 m6 l6 row-desc">
        <div [textContent]="cashCredit.amount*1000 | RupeeCurrencyPipe"></div>
        <div [textContent]="processingFee | RupeeCurrencyPipe"></div>
        <div [textContent]="disbursalAmount | RupeeCurrencyPipe"></div>
      </div>
    </div>
  </div>
</div>